import { useDisclosure } from "@chakra-ui/react";
import React, { useState } from "react";
import { CgNotes } from "react-icons/cg";
import { TreatmentPlanModal } from "../Modals/TreatmentPlanModal";

export const SingleExpertTreatmentPlanRow = ({ props }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { user_email, expert_id, expertName } = props;

  const [modal, setModal] = useState("");

  return (
    <tr>
      {/* <td>{expert_id}</td> */}
      <td>{expertName}</td>
      <td>{user_email}</td>
      <td>
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn disabledButton"
            onClick={() => {
              setModal("treatmentplanmodal");
              onOpen();
            }}
          >
            <CgNotes style={{ color: "#f48a0f" }} />
          </button>
        </div>
      </td>
      {modal === "treatmentplanmodal" && (
        <TreatmentPlanModal
          key={expert_id}
          isOpen={isOpen}
          onClose={onClose}
          user={user_email}
          expert={expert_id}
        />
      )}
    </tr>
  );
};
